import axiosBlank from './Flotex/blank'
import axiosBlankPreview from './Flotex/blankPreview'
import mockBlank from './Flotex/blankMock'
import axiosAuth from './Flotex/auth'
import axiosDictionary from './Flotex/dictionary'
import axiosPackages from './Flotex/packages'

export const client = {
  blank: axiosBlank,
  blankPreview: axiosBlankPreview,
  mockBlank: mockBlank,
  auth: axiosAuth,
  dictionary: axiosDictionary,
  packages: axiosPackages
}

export const ClientContainer = {
  get: (name) => {
    if (typeof client[name] !== 'undefined') {
      return client[name]
    }
  }
}

export default ClientContainer
